import React, { useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { data } from "react-router-dom";
export default function EditBot({
  handleSubmit,
  form,
  loading,
  setForm,
  isEdit,
  setIsEdit,
}) {
  const validationSchema = Yup.object().shape({
    category: Yup.string().required("* Required"),
    reply: Yup.string().required("* Required"),
  });

  const [phrase, setPhrase] = useState("");
  const [update, setUpdate] = useState(false);
  const [updateId, setUpdateId] = useState(0);

  return (
    <div className=" rounded-md border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="border-b border-stroke py-4 px-6.5 dark:border-strokedark">
        <h3 className="font-medium text-black dark:text-white">
          Update Bots Memory
        </h3>
      </div>
      <Formik
        initialValues={form}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {(formik) => (
          <Form>
            <div className="grid grid-cols-1 sm:grid-cols-2 pt-6.5">
              <div className="p-6.5 pt-0">
                <label className="mb-2.5 block text-black dark:text-white">
                  Category<span className="text-meta-1">*</span>
                </label>
                <Field
                  placeholder="Enter category name"
                  className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  name="category"
                  onChange={(e) => {
                    setForm({
                      ...form,
                      category: e.target.value,
                    });
                  }}
                  value={form.category}
                />
                <ErrorMessage
                  name="category"
                  component="a"
                  className="text-danger"
                />
              </div>

              <div className="p-6.5 pt-0">
                <label className="mb-2.5 block text-black dark:text-white">
                  Reply<span className="text-meta-1">*</span>
                </label>
                <Field
                  as="textarea"
                  rows={6}
                  placeholder="Enter the reply text"
                  className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  name="reply"
                  onChange={(e) => {
                    setForm({
                      ...form,
                      reply: e.target.value,
                    });
                  }}
                  value={form.reply}
                />
                <ErrorMessage
                  name="reply"
                  component="a"
                  className="text-danger"
                />
              </div>
              <div className="p-6.5 pt-0">
                <label className="mb-2.5 block text-black dark:text-white">
                  Phrases<span className="text-meta-1">*</span>
                </label>
                <div className="flex flex-col gap-5">
                  <input
                    placeholder="Enter phrase"
                    type="text"
                    value={phrase}
                    onChange={(e) => {
                      setPhrase(e.target.value);
                    }}
                    className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                  />

                  <button
                    type="button"
                    className="flex w-full justify-center border-[1.5px] rounded border-primary bg-transparent p-3 font-medium text-primary"
                    onClick={() => {
                      if (update) {
                        const array = [];
                        form.phrases.map((itm, index) => {
                          if (index === updateId) {
                            array.push(phrase);
                          } else {
                            array.push(itm);
                          }
                          return array;
                        });
                        setForm({
                          ...form,
                          phrases: array,
                        });
                        setUpdate(0);
                        setPhrase("");
                        setUpdate(false);
                      } else {
                        if (phrase !== "") {
                          const array = [...form.phrases];
                          array.push(phrase);
                          setForm({
                            ...form,
                            phrases: array,
                            category: form.category,
                            reply: form.reply,
                          });
                          setPhrase("");
                        } else {
                          alert("Must add a phrase before submiting");
                        }
                      }
                    }}
                  >
                    {update ? "Update Phrase" : "Add New Phrase"}
                  </button>
                  {form.phrases.map((itm, index) => (
                    <div className="w-full flex justify-between rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary">
                      <p>✅ {itm}</p>
                      <div className="flex gap-4">
                        <button
                          type="button"
                          onClick={() => {
                            setPhrase(itm);
                            setUpdate(true);
                            setUpdateId(index);
                          }}
                        >
                          🖍
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            const updatedPhrases = form.phrases.filter(
                              (_, i) => i !== index
                            );
                            setForm({
                              ...form,
                              phrases: updatedPhrases,
                            });
                          }}
                        >
                          🗑️
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="p-6.5 pt-0 flex gap-5">
              <button
                type="button"
                onClick={() => {
                  setIsEdit(!isEdit);
                  setForm({
                    ...data,
                    category: "",
                    phrases: [],
                    reply: "",
                  });
                }}
                className="flex w-[50%] justify-center border-[1.5px] rounded border-primary bg-transparent p-3 font-medium text-primary"
              >
                Add New Memory
              </button>
              <button
                type="submit"
                className="flex w-[50%] justify-center rounded bg-primary p-3 font-medium text-gray"
              >
                {loading ? (
                  <div className="flex h-auto items-center justify-center ">
                    <div className="h-6 w-6 animate-spin rounded-full border-4 border-solid border-white border-t-transparent"></div>
                  </div>
                ) : (
                  "Update Memory"
                )}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
